module.exports = __webpack_public_path__ + "static/media/Detection_Area_Light.6b379e11.svg";